import { render, staticRenderFns } from "./people-supporters.vue?vue&type=template&id=68fcd82f&scoped=true&"
import script from "./people-supporters.vue?vue&type=script&lang=js&"
export * from "./people-supporters.vue?vue&type=script&lang=js&"
import style0 from "./people-supporters.vue?vue&type=style&index=0&id=68fcd82f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fcd82f",
  null
  
)

export default component.exports